// TODO(BE-1951): TEMPORARY — first-clinic launch only; delete with src/complaints/.
import { complaintsClient } from "@complaints/complaintsClient";
import { useMutation } from "@tanstack/react-query";

export const useFileComplaint = () =>
  useMutation({
    mutationFn: complaintsClient.file,
    meta: { action: "send your report" },
  });
